// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fa99c400","656":"8b6b2b8c","751":"2f955bb0","780":"240c39fe","822":"21ac2ca7","831":"44bb846c","906":"2ff76afa","972":"f43ff51e"}[chunkId] + ".chunk.js";
};